import React from 'react'
import StatusBadge from '../../ui/status_badge'

const teams_card = ({teams}) => {
  return (
    <div className="p-2 card">
      <h3 className="text-center">Teams</h3>
      {teams.map(team => (
        <div key={team.teamName}>
          <div className="d-flex align-items-center justify-content-between flex-wrap pb-2">
            <h5>{team.name}</h5>
            <StatusBadge status={team.team_status}/>
          </div>
          {
            team.members.length > 0 ? 
              <ul>
                {team.members.map((member, index) => <li key={`${member}/${index}`}>{member}</li>)}
              </ul>
            :
            <p>No team members listed</p>
          }
        </div>
      ))}
    </div>
  )
}

export default teams_card